import React from 'react';
import styles from './BannedBanner.module.css';

const BannedBanner: React.FC = () => {
  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.icon}>⛔</div>
        <h1 className={styles.title}>Account Banned</h1>
        <p className={styles.body}>
          Your Njordheim account has been suspended and you can no longer access the game.
        </p>
        <p className={styles.body}>
          If you believe this is a mistake or would like to appeal, please contact us:
        </p>
        <ul className={styles.contactList}>
          <li>
            <span className={styles.contactLabel}>Discord (PM)</span>
            <a
              className={styles.contactLink}
              href="https://discord.com/users/xirez"
              target="_blank"
              rel="noopener noreferrer"
            >
              xirez
            </a>
            <span className={styles.contactNote}> on the Njordheim server</span>
          </li>
          <li>
            <span className={styles.contactLabel}>E-mail</span>
            <a className={styles.contactLink} href="mailto:xirez@njordheim.com">
              xirez@njordheim.com
            </a>
          </li>
        </ul>
        <p className={styles.footer}>
          Please include your username and a brief explanation when reaching out.
        </p>
      </div>
    </div>
  );
};

export default BannedBanner;
